/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import Moment from 'react-moment';
import { Link } from 'react-router-dom';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import SiteAddress from 'components/SiteAddress/SiteAddress';

import styles from 'common-scss/DetailsPage.module.scss';

//fix warning 'Mobx observer: You are trying to use 'observer' on a component that already has 'inject''
@translate()
@inject('assetStore')
@observer
export default class ProjectDetails extends React.Component<*> {
  render(): React.Element<*> {
    const t: Function = this.props.t;
    const project: Object = this.props.assetStore.asset.project;

    if (!project) {
      return (
        <div className={styles['project-tab']}>
          {t('general:assets.messages.currently_not_allocated')}
        </div>
      );
    }

    return (
      <div className={styles['project-tab']}>
        <h3>{t('general:projects.labels.lead')}</h3>
        <table>
          <tbody>
            <tr>
              <td>{`${project.lead.first_name} ${project.lead.last_name}`}</td>
            </tr>
          </tbody>
        </table>

        <h3>{t('general:projects.labels.details')}</h3>
        <table>
          <tbody>
            <tr>
              <td>
                <b>{t('general:projects.labels.name')}:</b>
              </td>
              <td>{project.name}</td>
            </tr>
            <tr>
              <td>
                <b>{t('general:projects.labels.code')}:</b>
              </td>
              <td>{project.code}</td>
            </tr>
            <tr>
              <td>
                <b>{t('general:projects.labels.description')}:</b>
              </td>
              <td>{project.description}</td>
            </tr>
            <tr>
              <td>
                <b>{t('general:projects.labels.start_date')}:</b>
              </td>
              <td>
                <Moment date={project.start_date} format="MMMM DD, YYYY" />
              </td>
            </tr>
            <tr>
              <td>
                <b>{t('general:projects.labels.end_date')}:</b>
              </td>
              <td>
                <Moment format="MMMM DD, YYYY">{project.end_date}</Moment>
              </td>
            </tr>
          </tbody>
        </table>

        <h3>{t('general:projects.labels.location')}</h3>
        <table>
          <tbody>
            <tr>
              <td>
                <b>{t('general:company')}:</b>
              </td>
              <td>
                {project.location.company.name || project.location.company.name === null
                  ? project.location.company.name
                  : project.location.company}
              </td>
            </tr>
            <tr>
              <td>
                <b>{t('general:locations.labels.site')}:</b>
              </td>
              <td>{project.location.site.name}</td>
            </tr>
            <tr>
              <td>
                <b>{t('general:locations.labels.site_address')}:</b>
              </td>
              <td>
                <SiteAddress {...project.location.site.address} />
              </td>
            </tr>
            <tr>
              <td>
                <b>{t('general:locations.labels.building_transport')}:</b>
              </td>
              <td>{project.location.building.name}</td>
            </tr>
            <tr>
              <td>
                <b>{t('general:locations.labels.lab_room')}:</b>
              </td>
              <td>{project.location.room.name}</td>
            </tr>
            <tr>
              <td>
                <b>{t('general:locations.labels.system_workspace')}:</b>
              </td>
              <td>{project.location.workspace.name}</td>
            </tr>
          </tbody>
        </table>

        <Link to={`/projects/${project.id}`}>
          <Button variant="contained" color="primary">
            {t('general:actions.view_project')}
          </Button>
        </Link>
      </div>
    );
  }
}
